import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import PageTransition from './components/effects/PageTransition';
import CommandPalette from './components/effects/CommandPalette';
import ErrorBoundary from './components/ErrorBoundary';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';
import WorkExperiencePage from './pages/WorkExperiencePage';
import WorkExperienceDetailPage from './pages/WorkExperienceDetailPage';
import CaseStudyPage from './pages/CaseStudyPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionPage from './pages/TermsConditionPage';
import NotFoundPage from './pages/NotFoundPage';
import { LanguageProvider } from './context/LanguageContext';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={
          <PageTransition><PortfolioPage /></PageTransition>
        } />
        <Route path="/contact-me" element={
          <PageTransition><ContactPage /></PageTransition>
        } />
        <Route path="/experience" element={
          <PageTransition><WorkExperiencePage /></PageTransition>
        } />
        <Route path="/experience/:id" element={
          <PageTransition><WorkExperienceDetailPage /></PageTransition>
        } />
        <Route path="/case-study/:slug" element={
          <PageTransition><CaseStudyPage /></PageTransition>
        } />
        <Route path="/privacy-policy" element={
          <PageTransition><PrivacyPolicyPage /></PageTransition>
        } />
        <Route path="/term-condition" element={
          <PageTransition><TermsConditionPage /></PageTransition>
        } />
        <Route path="*" element={
          <PageTransition><NotFoundPage /></PageTransition>
        } />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <ErrorBoundary>
          <LanguageProvider>
            <Router>
              <CommandPalette />

              <ScrollToTop />
              <div className="min-h-[100dvh] bg-[#0B0B0F] flex flex-col">
                <Header />
                <main className="flex-grow">
                  <AnimatedRoutes />
                </main>
                <Footer />
              </div>
            </Router>
          </LanguageProvider>
        </ErrorBoundary>
      </MotionConfig>
    </HelmetProvider>
  );
}

export default App;
